"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const WhiteBoxModal_1 = __importDefault(require("./WhiteBoxModal"));
var NotificationType;
(function (NotificationType) {
    NotificationType["SUCCESS"] = "success";
    NotificationType["WARN"] = "warn";
    NotificationType["ERROR"] = "error";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
const NotificationBoxModal = (0, styled_components_1.default)(WhiteBoxModal_1.default)(({ accentColorName, headerTextColorName, theme: { colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    '.modal-wrapper': {
        variant: 'modals.wideModalWrapper',
    },
    '.modal-header': {
        backgroundColor: colors[accentColorName],
        color: colors[headerTextColorName],
        border: 0,
        button: {
            '&:hover, &:focus': {
                color: 'white',
            },
        },
        fontSize: [null, 4],
        pr: [null, 3],
    },
    '.modal-body': {
        variant: 'modals.commonModalBody',
        border: '2px solid',
        borderTopWidth: 0,
        borderColor: colors[accentColorName],
    },
}));
const NotificationModal = props => {
    const { children, type, className } = props, modalProps = __rest(props, ["children", "type", "className"]);
    const accentColorName = {
        [NotificationType.SUCCESS]: 'success',
        [NotificationType.WARN]: 'warning',
        [NotificationType.ERROR]: 'error',
    }[type];
    const headerTextColorName = {
        [NotificationType.SUCCESS]: 'white',
        [NotificationType.WARN]: 'black',
        [NotificationType.ERROR]: 'white',
    }[type];
    return (react_1.default.createElement(NotificationBoxModal, Object.assign({ className: className, accentColorName: accentColorName, headerTextColorName: headerTextColorName }, modalProps), children));
};
exports.default = NotificationModal;
//# sourceMappingURL=NotificationModal.js.map